import React from 'react'
import { Link } from 'react-router-dom'
import Resx from '@/components/Resx'
import { ValidationState } from '@/components/validation'
import Icon from '@/components/Icon'
import { ButtonSection } from '@/components/Layout'
import { actionCreators } from '@/store/Messages'
import { MessagesTabs } from '@/enums/MessagesTabs'
import PermissionRequired from '@/components/auth/PermissionRequired'
import { useDispatch } from '@/hooks/dispatch'

const MessageEditButtons = function MessageEditButtons ({ isReply, message }) {
  const [saveMessage, saveMessageReply, saveAndSendMessage, saveAndSendMessageReply] = useDispatch(
    [actionCreators.saveMessage, actionCreators.saveMessageReply,
      actionCreators.saveAndSendMessage, actionCreators.saveAndSendMessageReply])
  const onSaveClick = (e) => {
    e.preventDefault()
    isReply ? saveMessageReply() : saveMessage()
  }

  const onSendClick = (e) => {
    e.preventDefault()
    isReply ? saveAndSendMessageReply() : saveAndSendMessage()
  }

  return (
    <ButtonSection>
      <Link className='btn btn-secondary btn-sm' to={message && message.id ? `/messages/${MessagesTabs.DRAFT}` : `/messages/${MessagesTabs.SENT}`}><Resx name='Common.Cancel' /></Link>
      <ValidationState render={({ isValid, serverError }) =>
        <React.Fragment>
          {serverError && serverError.message &&
            <span className='error'><Resx name={serverError.message} /></span>}
          <React.Fragment>
            <PermissionRequired name={['CanManageMessages', 'CanCreateDrafts']}>
              <button className='btn btn-success ml-auto' onClick={onSaveClick} disabled={!isValid}>
                <Icon name='save' />
                <span><Resx name='Messages.SaveAsDraft' /></span>
              </button>
            </PermissionRequired>

            <PermissionRequired name={'CanSendMessages'}>
              <PermissionRequired name={'CanManageMessages'}>
                <button className='btn btn-success ml-auto' onClick={onSendClick}
                  disabled={!isValid}>
                  <Icon name='save' />
                  <span><Resx name='Messages.Send' /></span>
                </button>
              </PermissionRequired>
            </PermissionRequired>
          </React.Fragment>
        </React.Fragment>
      } />
    </ButtonSection>
  )
}

export default MessageEditButtons



// WEBPACK FOOTER //
// ./src/components/messages/edit-buttons.js